import { useState, useEffect } from "react";
import { fetchFeaturedGames } from "../../services/api";
import "./RecentGames.css";

/* 6 placeholder cards */
const FALLBACK = [
  { _id: "r1", image: "/RG1.jpg" }, 
  { _id: "r2", image: "/RG2.jpg" }, 
  { _id: "r3", image: "/project_05.jpg" },
  { _id: "r4", image: "/RG4.jpg" }, 
  { _id: "r5", image: "/RG5.jpg" }, 
  { _id: "r6", image: "/RG6.jpg" },
];

export default function RecentGames() {
  const [games, setGames] = useState(FALLBACK);

  useEffect(() => {
    fetchFeaturedGames()
      .then((data) => { if (data && data.length) setGames(data); })
      .catch(() => {});
  }, []);

  return (
    <section className="recent-section section" id="recent">
      <div className="container">
        {/* header */}
        <div className="recent-header reveal">
          <h2 className="section-title">Our Recent Games</h2>
          <p>
            Explore some of our latest game projects crafted with creativity,
            cutting-edge technology, and player-centric design.
          </p>
        </div>

        {/* 3×2 grid */}
        <div className="recent-grid">
          {games.map((g, i) => (
            <div
              key={g._id}
              className="recent-card reveal"
              style={{ transitionDelay: `${i * 0.06}s` }}
            >
              <img 
                src={g.image || g.imageUrl} 
                alt={g.title || `Recent Game ${i + 1}`}
                className="recent-game-img"
                loading="lazy"
              />
            </div>
          ))}
        </div>

        {/* see all */}
        <div className="see-all-center reveal">
          <a href="#" className="btn-outline">SEE ALL</a>
        </div>
      </div>
    </section>
  );
}
